import { legacyRedirect } from './-components';
import { createFileRoute } from '@tanstack/react-router';

// The old `journeys` URL for the CDP source card, which the integrations directory still links to.
// The redirect into Pipelines lives at `/workspaces/:workspaceId/integrations/cdp_out`.
export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/integrations/cdp_out')({
  beforeLoad: legacyRedirect('/workspaces/:workspaceId/integrations/cdp_out'),
});
